import React from 'react'
import PropTypes from 'prop-types'
import {
  Accordion,
  AccordionButton,
  AccordionItem as ChakraAccordionItem,
  AccordionPanel,
  Box,
  Text,
  Image,
} from '@chakra-ui/react'
import AccordionCloseButton from '../../../../assets/images/reward_program/accordion_close_btn.svg'
import {getFaqData} from './faqData'

const AccordionIcon = ({isExpanded}) => (
  <Image
    src={AccordionCloseButton}
    alt={isExpanded ? 'Collapse' : 'Expand'}
    w="18px"
    h="18px"
    transform={isExpanded ? 'rotate(45deg)' : 'rotate(0deg)'}
    transition="transform 0.2s ease-in-out"
  />
)

AccordionIcon.propTypes = {
  isExpanded: PropTypes.bool.isRequired,
}

const FAQContent = ({content}) => {
  return (
    <Text textStyle="body-copy" dangerouslySetInnerHTML={{__html: content}} />
  )
}

FAQContent.propTypes = {
  content: PropTypes.string.isRequired,
}

const AccordionItem = ({title, children}) => (
  <ChakraAccordionItem
    borderTop="0px"
    _last={{borderBottom: '0px'}}
    paddingRight="xs"
  >
    {({isExpanded}) => (
      <>
        <AccordionButton
          borderBottom="1px"
          px="0"
          _hover={{bg: 'transparent', backgroundColor: 'transparent'}}
        >
          <Box flex="1" textAlign="left">
            <Text textStyle="body-intro">{title}</Text>
          </Box>
          <AccordionIcon isExpanded={isExpanded} />
        </AccordionButton>
        <AccordionPanel
          px="0"
          pb={4}
          bg="transparent"
          backgroundColor="transparent"
        >
          {children}
        </AccordionPanel>
      </>
    )}
  </ChakraAccordionItem>
)

AccordionItem.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
}

const FAQAccordion = ({t}) => {
  const faqData = getFaqData(t)

  return (
    <Accordion allowToggle paddingRight="xxs">
      {faqData.map((faq) => (
        <AccordionItem key={faq.id} title={faq.title}>
          <FAQContent content={faq.content} />
        </AccordionItem>
      ))}
    </Accordion>
  )
}

FAQAccordion.propTypes = {
  t: PropTypes.func.isRequired,
}

const FAQSection = ({t}) => {
  return (
    <Box display="flex" flexDirection="column" gap={{base: '0', md: '5'}}>
      <Text
        textStyle="headline3"
        fontSize={{base: '32px', md: '42px'}}
        fontWeight="medium"
        lineHeight="90%"
        letterSpacing="-0.05em"
        mb={{base: '4', md: '-0.3rem'}}
      >
        {t('supplierRewardsProgramLearnMoreModal.faq.title')}
      </Text>
      <FAQAccordion t={t} />
    </Box>
  )
}

FAQSection.propTypes = {
  t: PropTypes.func.isRequired,
}

export default FAQSection
